import s from './LoginWidget.module.css';
import { Button } from '@cian/ui-kit';

interface IAgreementsProps {
  onClose(): void;
}

export function Agreements({ onClose }: IAgreementsProps) {
  return (
    <div>
      <p className={s['agreements-paragraph']}>
        Настоящим я даю Обществу с ограниченной ответственностью «Айриэлтор» (владелец сайта www.cian.ru),
        местонахождение: 107023, г. Москва, ул. Электрозаводская, д.27 стр.8 (далее по тексту – Оператор), привлеченному
        им лицу ООО “Практика успеха”, местонахождение: 119180, г Москва, ул Большая Полянка, 51А/9, помещ. 1/1/8,
        согласие на обработку своих персональных данных: фамилия, имя, отчество, год, месяц, дата и место рождения,
        гражданство, основной документ, удостоверяющий личность (сведения о его номере, дате выдачи, выдавшем его органе
        и др.), идентификационный номер налогоплательщика, свидетельство государственного пенсионного страхования,
        адрес, семейное, социальное, имущественное положение, профессия, доходы, расходы, контактные данные (номер
        абонентского устройства подвижной радиотелефонной связи, адрес электронной почты, ip-адреса), трудовой стаж,
        сведения о работодателе, переданных мной Оператору при заполнении «Ипотечной анкеты» (далее – «Анкета») в
        электронном виде через сайт www.cian.ru, в целях получения услуг Оператора и/или партнеров Оператора, создания
        информационных систем персональных данных Оператора, проверки/уточнения предоставленных мною сведений на предмет
        полноты и достоверности, информирования и консультирования об услугах Оператора и/или партнеров Оператора путем
        направления информации с помощью средств связи по контактной информации, а также в любых других целях, прямо или
        косвенно связанных с получением услуг Оператора и/или партнеров Оператора, необходимых для подбора и оказания
        необходимых услуг, в которых я заинтересован и/или совершил действия для их получения.
      </p>
      <p className={s['agreements-paragraph']}>
        Даю согласие на обработку моих персональных данных любыми необходимыми Оператору способами, включая сбор,
        запись, систематизацию, накопление, хранение, уточнение (обновление, изменение), извлечение, использование,
        передачу (предоставление, доступ), обезличивание, блокирование, удаление, уничтожение персональных данных с
        использованием средств автоматизации или без использования таковых по усмотрению Оператора в целях заполнения
        полей моих анкет/заявлений в электронном виде на сайте www.cian.ru, в случае моего повторного и последующих
        обращений в целях получения услуг Оператора и/или партнеров Оператора. Даю согласие на обработку Оператором
        персональных данных в течение тридцати шести месяцев с момента предоставления настоящего согласия. Отзыв
        настоящего Согласия на обработку персональных данных может быть произведен в соответствии с законодательством
        Российской Федерации, в письменной форме, при условии направления Оператору письменного уведомления об этом.
      </p>
      <Button onClick={onClose}>Подтвердить</Button>
    </div>
  );
}
